export const getAppImageUrl = appMarketListing => {
  var _appMarketListing$ass;
  return (appMarketListing == null || (_appMarketListing$ass = appMarketListing.assetsMap) == null || (_appMarketListing$ass = _appMarketListing$ass.appIcon) == null || (_appMarketListing$ass = _appMarketListing$ass.assets) == null || (_appMarketListing$ass = _appMarketListing$ass[0]) == null ? void 0 : _appMarketListing$ass.url) || '';
};
export const getAppTermsOfUseUrl = appMarketListing => {
  var _appMarketListing$con;
  return (appMarketListing == null || (_appMarketListing$con = appMarketListing.contactInfo) == null ? void 0 : _appMarketListing$con.termsOfUseUrl) ?? '';
};
export const getAppNameAppMarket = appMarketListing => {
  var _appMarketListing$bas;
  return (appMarketListing == null || (_appMarketListing$bas = appMarketListing.basicInfo) == null ? void 0 : _appMarketListing$bas.name) || '';
};
//# sourceMappingURL=marketListing.js.map